import { create } from "zustand";
import { UserProfile } from "../../Typings/UserProfile";
import dayjs, { Dayjs } from "dayjs";
import { fromProfileTz, getDateUtc, getNowUtc, toProfileTz, toUtcEst } from "../../../MessagingCenter/Utils";

export const useUserProfileStore = create<IUserProfileStore>((set, get) => ({
  profile: {
    daylightSavingOffset: "-05:00:00",
    userAuthId: "",
    firstName: "",
    lastName: "",
    email: "",
    title: "",
    notifyOnEmailReply: false,
    notifyOnTextReply: false,
  } as UserProfile,
  setProfile: (profile: UserProfile) => set({ profile }),
  getUserAdjustedDate: (date: Date | Dayjs | string) => {
    const { profile } = get();

    if (profile.daylightSavingOffset) {
      return toProfileTz(getDateUtc(date), profile.daylightSavingOffset);
    }

    return toUtcEst(dayjs(date));
  },
  fromUserAdjustedDate: (date: Date | Dayjs | string) => {
    const { profile } = get();

    if (profile.daylightSavingOffset) {
      return fromProfileTz(getDateUtc(date), profile.daylightSavingOffset);
    }

    return toUtcEst(dayjs(date));
  },
  getUserAdjustedDateFromNow: (date: Date | Dayjs | string) => {
    return getDateUtc(date).from(getNowUtc());
  },
  hasValidTitle: () => {
    const { profile } = get();
    return Boolean(profile.title && profile.title.trim().length > 0);
  },
}));

export interface IUserProfileStore {
  profile: UserProfile;
  setProfile: (profile: UserProfile) => void;
  getUserAdjustedDate: (date: Date | Dayjs | string) => Dayjs;
  getUserAdjustedDateFromNow: (date: Date | Dayjs | string) => string;
  fromUserAdjustedDate: (date: Date | Dayjs | string) => Dayjs;
  hasValidTitle: () => boolean;
}
